import React from 'react';

import styled from '@emotion/styled';

import { CheckOutlineCircle, CloseOutlineCircle } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TableBodyRow } from 'uiToolkitV1/TableComponents';

export const AcceptOrDenyNomination = ({ handleAcceptClick, handleRejectClick }) => (
  <>
    <Button variant="rowButtonOutlined" onClick={handleAcceptClick} StartIcon={CheckOutlineCircle}>
      Accept
    </Button>
    <Button ml={3} variant="rowButtonTertiary" onClick={handleRejectClick} color="red" StartIcon={CloseOutlineCircle}>
      Deny
    </Button>
  </>
);

export const StyledReviewTableBodyRow = styled(TableBodyRow)(({ theme }) => ({
  '& .action': {
    display: 'none',
  },
  '&:hover': {
    cursor: 'pointer',
    '& .info': {
      display: 'none',
    },
    '& .action': {
      display: 'flex',
      marginRight: '12px',
    },
    'td:first-of-type p': {
      color: theme.colors.text['1565BC'],
    },
  },
}));
